import { PageHeader } from '@verantos-dev/shared-components';

import { useUsersListHeader } from '../hooks/useUsersListHeader';

export const UsersListHeader = () => {
  const { title, createUserActionBtn } = useUsersListHeader();

  return <PageHeader id="user-PageHeader" pageTitle={title} actions={createUserActionBtn} />;
};
